import React from "react";
import ReviewAttendanceModal from "./ReviewAttendanceModal";

const ReviewDieselModal = (props) => (
    <ReviewAttendanceModal
        {...props}
        reviewType="diesel"
    />
);

export default ReviewDieselModal;